// extracted by mini-css-extract-plugin
export default {"spinWrapper":"ReportModal_spinWrapper__jiDc+"};